import SideBarLayout from './side-bar-layout';

export default SideBarLayout;
